import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, WrenchIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { services } from '../../data/services';
import { ui } from '../../data/ui';
import { buttonClass } from '../../utils/styles';
import { SectionHeading } from '../SectionHeading';
export function ServicesShowcase() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist" aria-labelledby="services-heading" data-id="element-186" data-mp="2gg3w69ixilhy">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-187" data-mp="2lfgtxpbc9czb">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-188" data-mp="2li30pmqenogh">
          <SectionHeading id="services-heading" eyebrow={t({
          en: 'What we do',
          es: 'Lo que hacemos'
        })} title={t({
          en: 'Eight core services, one accountable crew',
          es: 'Ocho servicios principales, un solo equipo responsable'
        })} description={t({
          en: 'Everything from a single drywall patch to a full kitchen remodel. Pricing is always quoted in person after we see the work.',
          es: 'Desde un parche de drywall hasta la remodelación completa de una cocina. El precio siempre se cotiza en persona después de ver el trabajo.'
        })} data-id="element-189" data-mp="2qfuvcoifpood" />
          <Link to="/services" className={buttonClass('outline', 'md', 'shrink-0')} data-id="element-190" data-mp="20kk7r4036e9y">
            {t(ui.viewAllServices)}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-191" data-mp="2y6rf2lnrykq0" />
          </Link>
        </div>

        <ul className="mt-12 grid border-l border-t border-navy/10 bg-white sm:grid-cols-2 xl:grid-cols-4" data-id="element-192" data-mp="2t8pxk55zytgn">
          {services.map(service => <li key={service.slug} className="border-b border-r border-navy/10" data-id="element-193" data-mp="2jaiffizz25d2">
              <Link to={`/services#${service.slug}`} className="group flex h-full flex-col p-7 transition-colors duration-150 ease-out-expo hover:bg-gold-50" data-id="element-194" data-mp="1ctwxic2p7ck8">
                <service.icon className="h-8 w-8 text-navy" aria-hidden="true" data-id="element-195" data-mp="3w122bh2t0y6o" />
                <h3 className="mt-5 font-display text-xl leading-snug text-navy" data-id="element-196" data-mp="3vyy1j807cfam">
                  {t(service.name)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-197" data-mp="3m3e7kr577qoi">{t(service.short)}</p>
                <span className="mt-auto flex items-center gap-1.5 pt-6 text-sm font-semibold text-gold-dark" data-id="element-198" data-mp="3r167a7c34h39">
                  {t(ui.learnMore)}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out-expo group-hover:translate-x-0.5" aria-hidden="true" data-id="element-199" data-mp="3cbi8pdvafwj8" />
                </span>
              </Link>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col gap-4 rounded-lg bg-navy px-6 py-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-200" data-mp="38bg4oy22yr0s">
          <p className="flex items-center gap-3 text-navy-100" data-id="element-201" data-mp="2tga08fimv09k">
            <WrenchIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-202" data-mp="2yciku8flnlo4" />
            {t({
            en: 'Also available: handyman repairs, dumpster drop-off and same-day small jobs.',
            es: 'También disponible: reparaciones handyman, servicio de dumpster y trabajos pequeños el mismo día.'
          })}
          </p>
          <Link to="/contact" className={buttonClass('gold', 'sm', 'shrink-0')} data-id="element-203" data-mp="2jql6sol8dpua">
            {t(ui.freeEstimate)}
          </Link>
        </div>
      </div>
    </section>;
}